export const API_ENV = process.env.VUE_APP_API_ENV
export const NODE_ENV = process.env.NODE_ENV
